import { render, staticRenderFns } from "./hospitalPay.vue?vue&type=template&id=3fc93fa4&scoped=true"
import script from "./hospitalPay.vue?vue&type=script&lang=js"
export * from "./hospitalPay.vue?vue&type=script&lang=js"
import style0 from "./hospitalPay.vue?vue&type=style&index=0&id=3fc93fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc93fa4",
  null
  
)

export default component.exports